import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/gopal/Sushmita/aarohi/app/products/[slug]/AddToBag.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/gopal/Sushmita/aarohi/app/products/[slug]/PdpTracking.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/gopal/Sushmita/aarohi/app/products/[slug]/ProductGallery.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/gopal/Sushmita/aarohi/components/aarohi/ProductCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/Users/gopal/Sushmita/aarohi/node_modules/next/dist/client/app-dir/link.js");
